<template>
    <div v-if="bookkeepingAccount">
        <div class="flex w-full" @keydown.ctrl.shift.enter="save">
            <bank-account-picker v-model="selectedAccount" :bank-accounts="bankAccounts" />
        </div>
        <div class="flex md:col-span-2 gap-2 justify-end">
            <button class="mt-4 lg:mt-6 btn btn-outline btn-xs" @click="cancel">Avbryt</button>
            <button
                type="submit"
                class="mt-4 lg:mt-6 btn btn-primary btn-xs w-full lg:w-fit"
                :disabled="!selectedAccount"
                data-cy="click-save-button"
                @click="save"
            >
                <i class="i-mdi-content-save mr-2"/>
                Lagre
            </button>
        </div>
    </div>
    <div v-else/>
</template>

<script setup lang="ts">

import {assignBankAccount, fetchBankAccounts, bankAccounts} from '@/bank/bank-account.service'
import {onMounted, ref} from 'vue'
import {RichBankAccount} from '@/bank/bank.types'
import {fetchBookkeepingAccount} from '@/bookkeeping-account/bookkeepingAccount.service'
import BankAccountPicker from '@/bank/BankAccountPicker.vue'

const props = defineProps({
    bookkeepingAccount: {
        type: Object as () => { accountNo: string, displayName: string, subKey: string | null },
        required: true
    }
})

const emit = defineEmits(['save', 'cancel'])

const selectedAccount = ref<RichBankAccount>()

const save = async () => {
    if (selectedAccount.value && props.bookkeepingAccount?.accountNo) {
        await assignBankAccount({bookkeepingAccountNo: props.bookkeepingAccount?.accountNo, bankAccountUuid: selectedAccount.value.uuid})
        await fetchBankAccounts()
        await fetchBookkeepingAccount()
        emit('save')
    }
}

const cancel = () => {
    selectedAccount.value = undefined
    emit('cancel')
}

onMounted(async () => {
    await fetchBankAccounts()
})
</script>

<style scoped>

</style>